<ng-container [ngSwitch]="currentView">
  <a (click)="switchWorkspace(true)" *ngIf="addOwnWorkspace && user?.workspaces?.length > 1"><i
    class="close_embed screen db-icon db-icon-close"></i></a>
    <!-- UNIFIED VIEW FOR ALL TABS: BUSINESS/ECOMMERCE/AGENCY -->
    <div class="db-pricing-wrap"
         *ngSwitchDefault
         [class.dialog]="!static" [class.static]="static">
      <div class="with-scroll">
        <div class="db-one-week-free-demo">
          <div class="db-one-week-free-demo__header">
              <div class="content">
                <h1>
                  @if (currentSubscription?.platformPaidClient) {
                    Plans
                  } @else if (currentSubscription?.hostingTrialExpired && currentSubscription?.trialClient ) {
                    Upgrade to continue building with 10Web
                  }@else {
                    10Web Pro plans
                  }

                  @if (fromDomain) {
                    <a class="db-for-domain ds-btn-white-gray-border"><span>Free $30 domain included  🚀</span></a>
                  }

                </h1>


                <p class="db-subheader">
                  @if (!currentSubscription?.platformPaidClient) {
                    Select your plan to access website generation and hosting with fast, reliable, and superior performance.
                  } @else {
                    Have questions or need help choosing a plan? <a class="db-open-chat" (click)="openChat()">Chat with us</a>.
                  }
                </p>
              </div>

            @if (!currentSubscription?.platformPaidClient) {
              <div class="db-platform-pricing-plan_money-back">
                <div class="db-platform-pricing_money-back-title">
                  <i class="db-icon  db-icon-ds-checkmark-small-sharp"></i> <span> 30-day money back guarantee</span>
                <i class="db-icon db-icon-ds-whats-new"
                   dsTooltip="Valid before claiming your free domain."
                   dsTooltipAlign="left"
                   dsTooltipPosition="bottom"
                   dsTooltipColor="black"
                   dsTooltipSize="small"
                   [hostClass]="'cover-all'"
                ></i></div>

                <div class="db-platform-pricing_money-back-title">
                  <i class="db-icon  db-icon-ds-checkmark-small-sharp"></i> <span> No hidden fees</span></div>

                <div class="db-platform-pricing_money-back-title">
                  <i class="db-icon  db-icon-ds-checkmark-small-sharp"></i><span>{{ 'text_upgradePlanStarterCancelAnytime' | dbText}}</span></div>
              </div>
            }


            <div class="db-switch-with-tab mt18" *ngIf="shouldShowTabs()">
              <div class="db-tab-switcher">
                <div class="tab-option"
                     *ngIf="subscriptionsTabs?.business && subscriptionsTabs.business.length > 0"
                     [ngClass]="{'active': activeTab === 'business'}"
                     (click)="showBusiness()">
                  <span>Business</span>
                </div>
                <div class="tab-option"
                     *ngIf="subscriptionsTabs?.ecommerce && subscriptionsTabs.ecommerce.length > 0"
                     [ngClass]="{'active': activeTab === 'ecommerce'}"
                     (click)="showEcommerce()">
                  <span>Ecommerce</span>
                </div>
                <div class="tab-option {{!isSmallMobile && 'agency'}}"
                     *ngIf="subscriptionsTabs?.agency && subscriptionsTabs.agency.length > 0"
                     [ngClass]="{'active': activeTab === 'agency'}"
                     (click)="seeAgencyTab()">
                  <span>Agency @if(!isSmallMobile) {
                      (2+ websites)
                  } </span>
                </div>
              </div>

              <!-- Period Switch Component -->
              <div class="db-period-switch-coupon db-upgrade-plan__period-switch"
                   *ngIf="currentSubscription?.plan?.periodNumber !== 12 && hasUpgradeOptions()">
                <input class="ds-switcher-green ds-control-small"
                       type="checkbox"
                       [id]="'annual'"
                       [checked]="periodSwitch === 12">
                <label [for]="'annual'"
                       (click)="$event.preventDefault(); changePeriod()">
                  <p [class.monthly]="periodSwitch === 1">Annual discount (50%)</p>
                  <span class="ds-switcher-control"></span>
                </label>
              </div>
            </div>
          </div>
            <!-- Standard plans for business and ecommerce -->
            <ng-container *ngIf="activeTab === 'business'">
              <db-business-plans
                [subscriptions]="subscriptionsTabs?.business || []"
                [periodSwitch]="periodSwitch"
                [couponPercent]="couponPercent"
                [couponDays]="couponDays"
                [annualPrice]="annualPrice"
                [user]="user"
                [currentSubscription]="currentSubscription"
                [shouldStackPlans]="shouldStackPlans"
                [canSwitch]="!payments?.length && currentSubscription?.platformPaidClient"
                [showSwitchAnnual]="showSwitchAnnual"
                [invitedUser]="invitedUser"
                (onPaidSelect)="proceedToCheckout($event)"
                (onPlanSelect)="proceedToCheckout($event)">
              </db-business-plans>
            </ng-container>

            <ng-container *ngIf="activeTab === 'ecommerce'">
              <db-ecommerce-plans
                [subscriptions]="subscriptionsTabs?.ecommerce || []"
                [periodSwitch]="periodSwitch"
                [couponPercent]="couponPercent"
                [couponDays]="couponDays"
                [annualPrice]="annualPrice"
                [user]="user"
                [currentSubscription]="currentSubscription"
                [shouldStackPlans]="shouldStackPlans"
                [canSwitch]="!payments?.length && currentSubscription?.platformPaidClient"
                [showSwitchAnnual]="showSwitchAnnual"
                [invitedUser]="invitedUser"
                (onPaidSelect)="proceedToCheckout($event)"
                (onPlanSelect)="proceedToCheckout($event)">
              </db-ecommerce-plans>
            </ng-container>

            <!-- Agency-specific layout -->
            <ng-container *ngIf="activeTab === 'agency'">
              <db-agency-plans
                [subscriptions]="subscriptionsTabs?.agency || []"
                [periodSwitch]="periodSwitch"
                [allAvailableSubscriptions]="userHostingSubscriptions || []"
                [couponPercent]="couponPercent"
                [couponDays]="couponDays"
                [annualPrice]="annualPrice"
                [user]="user"
                [currentSubscription]="currentSubscription"
                [shouldStackPlans]="shouldStackPlans"
                [canSwitch]="!payments?.length && currentSubscription?.platformPaidClient"
                [showSwitchAnnual]="showSwitchAnnual"
                [invitedUser]="invitedUser"
                (onPlanSelect)="proceedToCheckout($event)"
                (onPaidSelect)="proceedToCheckout($event)"
                (onVMSelect)="proceedToCheckout($event)">
              </db-agency-plans>
            </ng-container>
          </div>
        </div>
      </div>

  <!-- CHECKOUT VIEW -->
  <div *ngSwitchCase="'checkout'" class="db-checkout__pricing-info">
    <ng-container *ngIf="chosenPlan">
      <db-pricing-page-checkout
        [userSubscription]="userSubscription"
        [expirationDate]="expirationDate"
        [user]="user"
        [hasBackBtn]="true"
        [chosenPlan]="chosenPlan"
        [couponCode]="couponCode"
        [couponPercent]="campaignInfo?.couponPercent || couponPercent"
        [couponDays]="campaignInfo?.couponDays || couponDays || 7"
        [hasCampaignCoupon]="hasCouponForCampaign && (chosenPlan?.category !== UserSubscriptionCategory?.DedicatedVM)"
        (onBack)="currentView = 'plans'; resizeToNormal()"
        (onClose)="closeModal($event, true)">
      </db-pricing-page-checkout>
    </ng-container>

  </div>
</ng-container>


<ng-template #reviewCarouselRef let-item='item'>
  <div class="db-one-month-free-checkout-info__carousel">
    <div class="mb8">
      <img src="{{item.img}}" alt="">
      <i [innerHTML]="'- ' + item.title"></i>
    </div>
    <p><i [innerHTML]="item.desc"></i></p>
  </div>
</ng-template>

<ng-template #copilot>
  <div class="video-tooltip">
    <p>EXPLORE AI COPILOT FEATURES</p>
    <!-- Image Instead of Video -->
    <div class="video-thumbnail" (click)="openVideoPopup()">
      <img src="assets/images/upgrade-plan/copilot_iframe.jpg"
           alt="Explore AI Copilot Features"/>
      <i class="db-icon db-icon-ds-media-play"></i>
    </div>
  </div>
</ng-template>
